<button
    mat-button
    data-test="buttons-picture"
    class="answer__button answer__button--multiple closecare-button primary-bg"
    (click)="pick()"
>
    {{answer?.button.label}}
</button>
<input #nativeCamera type="file" accept="image/*" capture="environment" id="camera" hidden (change)="fileTaken($event.target.files)">
<input #filePicker type="file" accept="image/*, application/pdf" hidden (change)="fileTaken($event.target.files)">